import React,{Component} from 'react';
import { connect } from 'react-redux';
import { Modal } from "react-bootstrap";
import { findDockets } from '../../../../actions/docketAction';
import { showHideNotificationModal } from '../../../../actions/uiAction';
import { Control, Field } from 'react-redux-form';
import { FooterContactSection } from '../../footer/FooterContactSection';
import { errorMessage,mediaPath } from "../../../../config";

class DocketPage extends Component {
	
	componentDidMount() {
		if(this.props.match.params.eCourtUserId!="" && this.props.match.params.eCourtUserId!=undefined){
			this.params =this.props.match.params;
		}
	}
	
	/* Function is used to close the modal */
	handleClose() {
		this.props.showHideNotificationModal(false);
	}
	render(){
		return (
			<div className="mydashboard-block">
                <div className="tab-block">
					<div className="container">
						<ul>
							<li>
									<a className="active">Active Cases</a>
							</li>
							<li>
									<a>Closed Cases</a>
							</li>
						</ul>
					</div>
				</div>
                <div className="mydocket-block">
					<div className="container">
						<div className="col-xs-12">
							<div className="enter-docket-number-block">
								<p>Please enter your unique 8 digit code<br/> found on your Notice of Hearing</p>
								<Control.text  model="myDocketform.uniqueCode" aria-required="true" aria-label="Please enter your unique 8 digit code found on your Notice of Hearing" required value={this.props.myDocketform.uniqueCode}/> 
								<div className="col-xs-12">
									<div className="eservice-block">
										<div className="eservice-heading-block">
											<label aria-label="Email preferences" className="eservice-heading">eService preference</label>
											<div className="overview-optedtooltip">
												<i class="fa fa-info-circle" aria-hidden="true"></i>
												<span className="tooltiptext" >By opting in to eService, you consent for any opposing parties of record to serve you electronically through ePortal. Any service requirements otherwise provided by law shall remain in effect. <b>This change will not affect your pending cases.  You will need to opt-in or opt-out in each of your pending cases.</b></span>
											</div>		
										</div>
										<Field model="myDocketform.e_services">
											<div className="radio-block" role="radiogroup" tabIndex="0">
												<span>
													<input role="radio" id="opt-in" aria-label="Opt-in"  name="Opt-in" type="radio" className="field radio" value="1" />
													<label className="" htmlFor="opt-in" >
														<span className="choice__text">Opt-in</span>
													</label>
												</span>
												<span>
													<input role="radio" id="opt-out" aria-label="Opt-out" name="Opt-out" type="radio" className="field radio" value="0" checked/>
													<label className="" htmlFor="opt-out" >
														<span className="choice__text">Opt-out</span>
													</label>
												</span>					
											</div>
										</Field>
									</div>
								</div>							  
								<div className="btn-block">
									<button type="button" onClick={()=>{this.props.findDockets({unique_code:this.props.myDocketform.uniqueCode,params:this.params,eServices:this.props.myDocketform.e_services})}} className="btn btn-default">Submit</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Modal show={this.props.uiState.notificationFlag} 
                  onHide={()=>this.handleClose()} 
                  backdrop="static" id="find-case"
                  className="modal fade select-files">
                  <Modal.Header>
                    <button type="button" className="close" onClick={()=>this.handleClose()} ><img src={mediaPath+"close.png"} alt="close" /></button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
						<div className="col-xs-12">
								<p className="note">Thank you for logging into ePortal. You have a new case available. An email has been sent to you with instructions on how to access your case.</p>
						</div>
					</div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="btn-block">
                      <button type="button" className="btn cancel" onClick={()=>this.handleClose()}>Close</button>
                    </div>
                  </Modal.Footer>
                </Modal>
				<FooterContactSection/>
			</div>
		)
	}
}

function mapStateToProps(state) {
  return {
	  myDocketform : state.myDocketform,
	  uiState : state.uiState
  };
}

export default connect(mapStateToProps, {findDockets,showHideNotificationModal})(DocketPage);